"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _Button = _interopRequireDefault(require("@mui/material/Button"));
// Import Button from the correct path

var StyledButton = (0, _styles.styled)(_Button.default)(function (_ref) {
  var theme = _ref.theme;
  return {
    "&.MuiButton-root": {
      textTransform: "capitalize"
    },
    "&.MuiButton-outlined": {
      borderColor: "#ff5958",
      color: "#ff5958"
    },
    "&.MuiButton-contained": {
      borderColor: "#ff5958",
      backgroundColor: "#ff5958",
      color: "#ffff"
    },
    "&:disabled": {
      borderColor: "#C5C5C5",
      color: "#C5C5C5",
      cursor: "not-allowed",
      pointerEvents: "all"
    }
  };
});
var _default = StyledButton;
exports.default = _default;